/** The single working route: a coming-soon landing page. */
export function ComingSoon() {
  return (
    <main className="site site-light">
      <img
        className="site-logo"
        src="/brand/logo.png"
        alt="Asset Integrity Solutions, LLC"
        width={220}
        height={220}
      />
      <div className="site-body">
        <p className="site-eyebrow">Coming Soon</p>
        <h1 className="site-title">We&rsquo;re getting ready to launch</h1>
        <p className="site-text">
          Our new website is on its way. We&rsquo;re working hard to give you the best possible
          experience. Please check back soon.
        </p>
      </div>
      <footer className="site-footer">
        &copy; {new Date().getFullYear()} Asset Integrity Solutions, LLC. All rights reserved.
      </footer>
    </main>
  );
}
